// AS TRAINING — Success stories / transformations data
// Contenido REAL de clientes autorizados. Actualizar cuando haya nuevos casos.
// NOTA: si un caso tiene poster_url se muestra la imagen completa (poster branded).
// Si tiene before_url + after_url se muestra el slider antes/después interactivo.
//
// Todas las estadísticas de la página se computan automáticamente desde este array.
// Añade una nueva historia con el campo `objective` correcto (fat_loss, muscle_gain,
// recomposition, performance, wellness) y aparecerá en su categoría automáticamente.

export const TRANSFORMATIONS = [
  {
    id: "laritza",
    name: "Laritza",
    age: 28,
    gender: "female",
    objective: "recomposition",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 16,
    weight_before: 145,
    weight_after: 130,
    weight_unit: "lb",
    key_result: "-15 lb + músculo",
    highlights: ["Perdió 15 lb", "Ganó masa muscular", "Recomposición completa"],
    testimonial: "Con AS TRAINING logré la disciplina que necesitaba. Cambié mi cuerpo y mi mentalidad.",
    rating: 5,
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/uike96td_file_00000000e110720c8344ead05ba3c922.png",
    video_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/jtxzhpr0_88972378_1788131842254043.mp4",
  },
  {
    id: "dina",
    name: "Dina",
    age: 33,
    gender: "female",
    objective: "recomposition",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 20,
    weight_before: 174.61,
    weight_after: 165,
    weight_unit: "lb",
    key_result: "-9.6 lb + músculo",
    highlights: ["Bajó 9.6 lb", "Ganó músculo", "Cambió su físico"],
    testimonial: "AS TRAINING me devolvió la confianza en mí misma. Cada semana veía los resultados.",
    rating: 5,
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/24ji9den_file_000000002a5c71fba545b6298af0eff7.png",
  },
  {
    id: "dyanelis",
    name: "Dyanelis",
    age: 34,
    gender: "female",
    objective: "fat_loss",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 24,
    weight_before: 200,
    weight_after: 162,
    weight_unit: "lb",
    key_result: "-38 lb",
    highlights: ["Perdió 38 lb", "Ganó masa muscular", "Transformación total"],
    testimonial: "Con AS TRAINING recuperé mi salud y mi figura. La disciplina y el seguimiento hicieron toda la diferencia.",
    rating: 5,
    before_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/sr1hc4tw_IMG-20260629-WA0003.jpg",
    after_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/2fzh1d2d_IMG-20260629-WA0005.jpg",
  },
  {
    id: "alex_green",
    name: "Alex Green",
    age: 38,
    gender: "male",
    objective: "muscle_gain",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 24,
    weight_before: 75,
    weight_after: 77,
    weight_unit: "kg",
    key_result: "+7.2 kg de músculo",
    highlights: ["+7.2 kg de masa muscular", "-5.3 kg de grasa corporal", "Más fuerza y confianza"],
    testimonial: "Gracias a AS Training y a mi entrenador Fabricio Almeida, logré transformar mi cuerpo y mi mente. Entrenamientos personalizados, nutrición adecuada y seguimiento constante me ayudaron a ganar masa muscular, perder grasa y sentirme mejor que nunca. Hoy soy más fuerte, más saludable y más seguro de mí mismo. ¡Los resultados hablan por sí solos!",
    rating: 5,
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/ufe6v4v8_file_00000000083c722f8dd05a3e578054a8.png",
  },
  {
    id: "chelito_green",
    name: "Chelito Green",
    age: 26,
    gender: "male",
    objective: "recomposition",
    plan: "evolution",
    plan_name: "AS EVOLUTION",
    duration_weeks: 20,
    weight_before: 70,
    weight_after: 72,
    weight_unit: "kg",
    key_result: "+definición · +músculos",
    highlights: ["Ganó más definición muscular", "Ganó más músculos", "Recomposición corporal"],
    testimonial: "Con disciplina, nutrición y el apoyo correcto, los resultados son inevitables. AS TRAINING me llevó al siguiente nivel.",
    rating: 5,
    poster_url: "https://customer-assets.emergentagent.com/job_as-training/artifacts/vf5u4k5f_file_000000002bf4720c8a3498773d62b8d7.png",
  },
  {
    id: "carlos_ocola",
    name: "Carlos Ocola",
    age: 30,
    gender: "male",
    objective: "recomposition",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 16,
    weight_before: 82,
    weight_after: 70,
    weight_unit: "kg",
    key_result: "-12 kg + definición",
    highlights: [
      "Menor porcentaje de grasa corporal",
      "Mayor definición muscular",
      "Más energía y mejor condición física",
      "Más confianza y autoestima",
    ],
    testimonial: "Cuando empecé con AS TRAINING sabía que necesitaba un cambio, pero no imaginaba cuánto podía transformar mi cuerpo y mi estilo de vida. En pocas semanas reduje significativamente mi porcentaje de grasa, mejoré mi condición física y hoy me siento con mucha más energía y confianza. Lo que más me gustó fue el seguimiento constante, el entrenamiento personalizado y el plan de alimentación adaptado a mis necesidades. Nunca me sentí solo durante el proceso. Hoy no solo veo un cambio físico, también gané disciplina y hábitos que me acompañarán para siempre. Gracias a Fabricio y al equipo de AS TRAINING por ayudarme a lograr mi mejor versión. ¡Esto apenas comienza!",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/aosdhwie_file_00000000b18081f79ca2eed032c4caab.png",
  },
  {
    id: "luisa_mora",
    name: "Luisa Mora",
    age: 32,
    gender: "female",
    objective: "recomposition",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 20,
    weight_before: 146.28,
    weight_after: 159.06,
    weight_unit: "lb",
    key_result: "+12.78 lb músculo · -6.8% grasa",
    highlights: [
      "Grasa corporal: 30.5% → 23.7%",
      "+12.78 lb de masa muscular",
      "Más fuerza, energía y confianza",
      "Cambio de hábitos permanentes",
    ],
    testimonial: "Cuando empecé con AS Training quería transformar mi cuerpo de una forma saludable y enfocarme en ganar masa muscular sin descuidar mi salud. Gracias al entrenamiento personalizado, la alimentación adecuada y el seguimiento constante de Fabricio Almeida, logré resultados que nunca imaginé. Mi peso pasó de 146.28 lb a 159.06 lb, aumentando masa muscular de calidad, mientras reduje mi porcentaje de grasa corporal de 30.50% a 23.70%. Me siento mucho más fuerte, con más energía, más confianza y orgullosa de todo el proceso. No solo cambié mi físico, también cambié mis hábitos y mi estilo de vida. Recomiendo totalmente AS Training a cualquier persona que quiera resultados reales con un plan profesional y un acompañamiento constante. ¡Vale la pena cada esfuerzo!",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/b3rmbzfx_file_00000000a44081f5a3216812f924477a.png",
  },
  {
    id: "richard",
    name: "Richard",
    age: 30,
    gender: "male",
    objective: "muscle_gain",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 20,
    weight_before: 170,
    weight_after: 198,
    weight_unit: "lb",
    key_result: "+28 lb de músculo",
    highlights: [
      "+28 lb de masa muscular",
      "Físico más fuerte y voluminoso",
      "Más energía y confianza",
      "Resultados reales visibles",
    ],
    testimonial: "Decidí comenzar mi transformación con AS Training porque quería desarrollar un físico más fuerte y ganar masa muscular de forma saludable. Desde el primer día recibí un plan de entrenamiento personalizado, orientación nutricional y un seguimiento constante que marcaron la diferencia. Gracias a la dedicación y al apoyo de Fabricio Almeida, pasé de 170 lb a 198 lb, logrando una ganancia significativa de masa muscular. Hoy me siento mucho más fuerte, con mayor energía y confianza, y los resultados hablan por sí solos. Lo que más valoro de AS Training es el compromiso, la motivación y el profesionalismo durante todo el proceso. Si realmente quieres transformar tu cuerpo y alcanzar tus objetivos, recomiendo totalmente AS Training. ¡Los resultados son reales!",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/pci2jcxp_file_00000000cb2c81f5975ee89243d4bae6.png",
  },
  {
    id: "roy",
    name: "Roy",
    age: 35,
    gender: "male",
    objective: "fat_loss",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 16,
    weight_before: 190,
    weight_after: 180,
    weight_unit: "lb",
    key_result: "-10 lb · preservó músculo",
    highlights: [
      "-10 lb de grasa corporal",
      "Preservó masa muscular",
      "Mejor composición corporal",
      "Nuevo estilo de vida saludable",
    ],
    testimonial: "Llegué a AS Training con el objetivo de perder grasa corporal sin sacrificar mi masa muscular. Gracias al entrenamiento personalizado, un plan de alimentación adaptado a mis necesidades y el seguimiento constante de Fabricio Almeida, logré una transformación que superó mis expectativas. Mi peso pasó de 190 lb a 180 lb, mejorando mi composición corporal y sintiéndome mucho más fuerte, saludable y con mayor confianza. Aprendí a entrenar y alimentarme de la manera correcta, convirtiendo este proceso en un nuevo estilo de vida. Estoy muy agradecido con AS Training por el apoyo, la motivación y el profesionalismo durante todo el camino. Si buscas resultados reales y un cambio duradero, recomiendo totalmente AS Training.",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/8tfjteb0_file_00000000ee0c81f5ad5d9fa1bb297e23.png",
  },
  {
    id: "ariana",
    name: "Ariana",
    age: 28,
    gender: "female",
    objective: "wellness",
    plan: "evolution",
    plan_name: "AS EVOLUTION",
    duration_weeks: 12,
    weight_before: 140.54,
    weight_after: 137.57,
    weight_unit: "lb",
    key_result: "Cuerpo tonificado + hábitos",
    highlights: [
      "Cuerpo más tonificado",
      "Más fuerza y energía",
      "Mucha más confianza",
      "Hábitos saludables duraderos",
    ],
    testimonial: "Comencé mi proceso con AS Training porque quería mejorar mi condición física y sentirme más saludable. Desde el primer día recibí un plan de entrenamiento personalizado, una guía nutricional adaptada a mis necesidades y el apoyo constante de Fabricio Almeida. Durante este proceso pasé de 140.54 lb a 137.57 lb. Aunque el cambio en la balanza fue pequeño, la diferencia en mi cuerpo y en mi bienestar ha sido enorme. Me siento más fuerte, con más energía, más tonificada y con mucha más confianza en mí misma. Lo que más valoro de AS Training es el compromiso, la motivación y el seguimiento personalizado que recibí en cada etapa. Si buscas resultados reales y un cambio de hábitos que dure toda la vida, recomiendo completamente AS Training.",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/pabuudq0_file_00000000f7b481f7a0b7278d79912ca1.png",
  },
  {
    id: "maria_patricia",
    name: "María Patricia",
    age: 30,
    gender: "female",
    objective: "muscle_gain",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 16,
    weight_before: 113.76,
    weight_after: 120.59,
    weight_unit: "lb",
    key_result: "+6.83 lb de músculo",
    highlights: [
      "+6.83 lb de masa muscular",
      "Cuerpo más fuerte y firme",
      "Más energía y confianza",
      "Cambio saludable y sostenible",
    ],
    testimonial: "Decidí comenzar mi proceso con AS Training porque quería aumentar mi masa muscular de forma saludable y fortalecer mi cuerpo. Desde el primer día recibí un entrenamiento personalizado, una alimentación adaptada a mis objetivos y el acompañamiento constante de Fabricio Almeida. Gracias a la disciplina y al excelente seguimiento, pasé de 113.76 lb a 120.59 lb, logrando una ganancia de masa muscular que me hizo sentir más fuerte, con más energía y mucha más confianza en mí misma. Cada entrenamiento fue un paso más hacia mi mejor versión. Estoy muy agradecida con AS Training por el profesionalismo, la motivación y el compromiso durante todo el proceso. Recomiendo este programa a todas las personas que quieran obtener resultados reales y transformar su cuerpo de manera saludable.",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/dxcqtpv7_file_000000004af481f5adea38564126ccb6.png",
  },
  {
    id: "haede",
    name: "Haede",
    age: 45,
    gender: "female",
    objective: "recomposition",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 20,
    weight_before: 167.44,
    weight_after: 163.58,
    weight_unit: "lb",
    key_result: "-3.86 lb · -0.7% grasa · +músculo",
    highlights: [
      "Peso: 167.44 → 163.58 lb (-3.86 lb)",
      "Grasa corporal: 46.20% → 45.50%",
      "IMC: 30.80 → 30.10",
      "Más fuerza, energía y confianza",
    ],
    testimonial: "Estoy muy feliz con mi transformación. Cuando comencé, no imaginaba cuánto podía cambiar mi cuerpo y, sobre todo, cómo podía cambiar mi forma de sentirme conmigo misma. Con AS Training aprendí que los resultados no llegan de un día para otro: se construyen con disciplina, constancia, entrenamiento y una buena alimentación. Hoy me siento más fuerte, con más energía, más segura y orgullosa de todo lo que he conseguido. Gracias, Fabricio Almeida, por el acompañamiento, la motivación y por ayudarme a no rendirme. Este resultado demuestra que cuando decides cambiar, todo es posible. ¡Estoy muy orgullosa de mi nueva versión!",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/aj6pnw84_file_00000000fe9881f787ff37232106ed7f.png",
    video_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/v7a9o158_755621452_1788125100378290.mp4",
  },
  {
    id: "claudia",
    name: "Claudia",
    age: 25,
    gender: "female",
    objective: "recomposition",
    plan: "elite",
    plan_name: "AS ELITE",
    duration_weeks: 20,
    weight_before: 138,
    weight_after: 132,
    weight_unit: "lb",
    key_result: "Abdomen definido · recomposición",
    highlights: [
      "Abdomen visiblemente definido",
      "Más energía y disciplina",
      "Hábitos saludables permanentes",
      "Más confianza y orgullo personal",
    ],
    testimonial: "Estoy súper feliz con los resultados que he conseguido con AS Training. Cuando comencé, sabía que quería cambiar, pero no imaginaba cuánto podía transformar mi cuerpo, mi energía y mi confianza. Gracias al entrenamiento personalizado, la disciplina y el seguimiento constante de Fabricio Almeida, aprendí a ser constante y a no buscar resultados fáciles. Cada entrenamiento ha sido un paso más hacia una versión más fuerte y saludable de mí misma. Hoy me siento orgullosa de mi progreso y, sobre todo, feliz de haber tomado la decisión de comenzar. Estoy muy agradecida con AS Training por acompañarme en este proceso y ayudarme a demostrar que cuando existe disciplina, enfoque y constancia, los resultados llegan. ¡Estoy feliz con mi transformación y voy por más!",
    rating: 5,
    poster_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/q64pfxcs_file_00000000417c81f5921fe9f6e041dbb2.png",
    video_url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_as-training/artifacts/olv5d0iw_345139391_1788177201560053.mp4",
  },
];

export const OBJECTIVE_LABELS = {
  fat_loss: "Pérdida de grasa",
  muscle_gain: "Ganancia muscular",
  recomposition: "Recomposición corporal",
  performance: "Mejora de rendimiento",
  wellness: "Bienestar y salud",
};

export const OBJECTIVE_ICONS = {
  fat_loss: "Fire",
  muscle_gain: "Barbell",
  recomposition: "ArrowsClockwise",
  performance: "Lightning",
  wellness: "Heart",
};

// ============ Static credibility (edit here) ============
export const CREDIBILITY = {
  years_experience: 10,
  renewal_rate_pct: 87,
  satisfaction_pct: 100,
  countries: 5,
};

// ============ Dynamic computations from TRANSFORMATIONS ============

/** Convert weight to lb regardless of source unit. */
function toLb(value, unit) {
  return unit === "kg" ? value * 2.20462 : value;
}

export function computeGlobalStats() {
  const total = TRANSFORMATIONS.length;
  let totalLbLost = 0;
  let sumRating = 0;
  for (const t of TRANSFORMATIONS) {
    if (t.objective === "fat_loss") {
      const before = toLb(t.weight_before, t.weight_unit);
      const after = toLb(t.weight_after, t.weight_unit);
      const diff = before - after;
      if (diff > 0) totalLbLost += diff;
    }
    if (t.objective === "recomposition") {
      const before = toLb(t.weight_before, t.weight_unit);
      const after = toLb(t.weight_after, t.weight_unit);
      const diff = before - after;
      if (diff > 0) totalLbLost += diff;
    }
    sumRating += t.rating || 0;
  }
  const avgRating = total > 0 ? sumRating / total : 0;
  return {
    clients: total,
    pounds_lost: Math.round(totalLbLost),
    satisfaction_pct: CREDIBILITY.satisfaction_pct,
    rating: Math.round(avgRating * 10) / 10,
    years_experience: CREDIBILITY.years_experience,
    renewal_rate_pct: CREDIBILITY.renewal_rate_pct,
  };
}

export function computeCategoryStats(objective) {
  const items = TRANSFORMATIONS.filter((t) => t.objective === objective);
  const count = items.length;
  if (count === 0) {
    return { objective, count: 0, avg_weeks: null, featured: null, items: [] };
  }
  const avgWeeks = Math.round(items.reduce((a, b) => a + b.duration_weeks, 0) / count);
  // Featured = first case
  const featured = items[0];
  return { objective, count, avg_weeks: avgWeeks, featured, items };
}

/** All objectives, always in order, even when empty. */
export function computeAllCategoryStats() {
  return Object.keys(OBJECTIVE_LABELS).map((o) => computeCategoryStats(o));
}
